import { useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api"

export function useDeleteTrigger({ onSuccess }: { onSuccess?: () => void } = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await api.delete<void>(`/api/triggers/$id`, undefined, {
        pathReplace: { $id: id }
      })
      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["triggers"] })
      if (onSuccess) onSuccess()
    },
  })
}
